<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @purchaseInbound="choosePtyPurchaseVisible = true"
        @directInbound="openEditPage({ pageType: 'add' })"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    
    <ChooseftyPurchase
      :visible.sync="choosePtyPurchaseVisible"
      url="/ecom/amz/fty/purchase/listByInbound"
      :amzPurchaseStatus="['N', 'Y']"
      :tableHeight="400"
      reserve
      @confirm="choosePtyPurchaseConfirm"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import ChooseftyPurchase from '../choose-fty-purchase'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, ChooseftyPurchase },
  data() {
    return { usePage: true, choosePtyPurchaseVisible: false }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzFtyInboundListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    async choosePtyPurchaseConfirm(data) {
      if (!data) return
      const { amzPurchaseCode } = data
      this.loadingOpen()
      const res = await this.$api
        .ecomAmzFtyInboundGenerateApi({ amzPurchaseCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res || {}
      if (status !== 200) {
        this.$message.error('入库失败！')
        return
      }
      this.choosePtyPurchaseVisible = false
      const { amzFtyInboundCode, amzFtyInboundNo } = res.body
      this.openEditPage({
        pageType: 'edit',
        params: { amzFtyInboundCode },
        query: { amzFtyInboundNo },
      })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'ecom-awsBiz-ftyInbound-detail',
        params: { ...params, pageType },
        query,
      })
    },
  },
}
</script>
